export default __webpack_public_path__ + "static/radio-mors.df2cd724-ca45fc200d6ec801d3b003ebd2916170.webp";